<template>
  <div id="feedforwardError">
    <el-card
      :style="{width: dialogWidth}"
      shadow="hover"
    >
      {{ errorText }}
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    errorText: {
      type: String,
      default: () => this.$t('coworker.feedforward.alreadySubmitted'),
    },
    dialogWidth: {
      type: String,
      default: '50%',
    },
  },
};
</script>

<style lang="scss" scoped>
#feedforwardError {
  width: 100%;

  .el-card {
    width: 35%;
    margin: 0 auto;
    font-weight: bold;
    background-color: rgba(255, 255, 255, 0.9);
  }
}
</style>
